import React from "react";
import AddOrEditTarifForm from "../form/AddOrEditTarifForm";
import { Tarif } from "../../../../utils/api/tarif/tarif.type";
import { Input } from "../../../common/Input";
import { BtnSubmit } from "../../../common/Button";

function AddOrEditTArifModal({
  modalId,
  item,
}: {
  modalId: string;
  item?: Tarif;
}) {
  const { register, onSubmit, isLoading, handleReset, errors } =
    AddOrEditTarifForm(modalId, item);
  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex={-1}
      data-bs-backdrop="static"
      aria-labelledby={modalId + "Label"}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id={modalId + "Label"}>
              Tarif
            </h1>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => handleReset()}
            ></button>
          </div>
          <div className="modal-body">
            <div className="pt-3">
              <form onSubmit={onSubmit}>
                <div className="row auth-form-row">
                  <div className="col-md-12 mb-3">
                    <Input
                      type="text"
                      label="Dénomination"
                      id="Dénomination"
                      placeholder="Dénomination"
                      {...register("denomination")}
                      required
                      error={errors?.denomination?.message}
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <Input
                      type="number"
                      min={0}
                      step={"any"}
                      label="Montant"
                      id="Montant"
                      placeholder="Montant"
                      {...register("montant")}
                      required
                      error={errors?.montant?.message}
                    />
                  </div>

                  <div className="flex-r">
                    <button
                      className="btn btn-cancelled"
                      type="button"
                      onClick={() => handleReset()}
                    >
                      Annuler
                    </button>
                    <BtnSubmit
                      label="Enregistrer"
                      isLoading={isLoading}
                      customClass="w-auto"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddOrEditTArifModal;
